import { useQuery } from "@tanstack/react-query";
import { getRound } from "../api/rounds";
import type { Round } from "../types";

const POLLING_STATUSES = new Set(["pending", "transcribing", "processing"]);

export function useRoundPolling(roundId: string | null | undefined) {
	return useQuery<Round>({
		queryKey: ["round", roundId],
		queryFn: () => {
			if (!roundId) {
				throw new Error("roundId is required");
			}
			return getRound(roundId);
		},
		refetchInterval: (query) => {
			const status = query.state.data?.status;
			return status && POLLING_STATUSES.has(status) ? 3000 : false;
		},
		enabled: !!roundId,
	});
}
